// Kept apart from config.ts (which reads window at load) so it can be tested without a browser.
/** Only a path on this origin ("/x", not "//host" or a URL), so the state cannot redirect elsewhere. */
export function returnPath(state: unknown): string | undefined {
  const returnTo = (state as { returnTo?: unknown } | undefined)?.returnTo;
  return typeof returnTo === 'string' && /^\/(?![/\\])/.test(returnTo) ? returnTo : undefined;
}
